// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomNode_root__338D7","expandIconWrapper":"CustomNode_expandIconWrapper__3Wfpy","isOpen":"CustomNode_isOpen__AcHla","labelGridItem":"CustomNode_labelGridItem__cyBfR"};